import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByProp',
  pure: false,
  standalone: false
})
export class FilterByPropPipe implements PipeTransform {
  public transform(items: any[], prop: any, value: any, forceNull = false): any[] {
    return (prop || prop === null) && (value || (value === null && forceNull)) && value !== -1
      ? items.filter((item) => item[prop] === value)
      : items;
  }
}
